import { render, staticRenderFns } from "./brandseries.vue?vue&type=template&id=460ffd96&scoped=true&"
import script from "./brandseries.vue?vue&type=script&lang=js&"
export * from "./brandseries.vue?vue&type=script&lang=js&"
import style0 from "./brandseries.vue?vue&type=style&index=0&id=460ffd96&lang=less&scoped=true&"
import style1 from "./brandseries.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ffd96",
  null
  
)

export default component.exports